import React from 'react';
import PropTypes from 'prop-types';
import {
	BottomTwoLevelTableRow,
	BottomTwoLevelItem,
	MainItem,
	CaretIconWrapper,
	BottomTwoLevelGreyItem,
	BottomTwoLevelDetailItem,
	BottomTwoLevelRightItem,
} from './style/bottom_two_level_style';
import {CaretIcon} from '../../../icons/caret-icon/caret_icon';

export const BottomTwoLevelRow = ({
	isLastRow,
	isFirstRow,
	isExpanded,
	mainItem,
	enabledColumns,
	showBottom,
	stickyTopPosition,
	numberOfLevels,
	isVisible,
	bottomTwoItems,
	bottomTwoRightItems,
	bottomTwoDetailItems,
	bottomTwoGreyItems,
	numberOfParents,
}) => {
	const show = () => {
		showBottom();
	};

	const list = [];
	let index = 0;

	if (isVisible) {
		if (enabledColumns.caretIcon !== undefined && enabledColumns.caretIcon !== 0) {
			list.push(
				<CaretIconWrapper key={index} order={enabledColumns.caretIcon}>
					<CaretIcon
						size={CaretIcon.SIZE.STANDARD}
						color={'#000'}
						direction={isExpanded === true && CaretIcon.DIRECTION.UP}
					/>
				</CaretIconWrapper>
			);
			index++;
		}

		//add the main item to the list
		if (enabledColumns.mainItem !== undefined && enabledColumns.mainItem !== 0) {
			list.push(
				<MainItem key={index} order={enabledColumns.mainItem}>
					<span>{mainItem}</span>
				</MainItem>
			);
			index++;
		}

		if (bottomTwoItems) {
			//looping through the bottom 2 simple items
			for (const key of Object.keys(bottomTwoItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomTwoLevelItem order={enabledColumns[key]} key={index}>
							<span>{bottomTwoItems[key]}</span>
						</BottomTwoLevelItem>
					);
					index++;
				}
			}
		}

		if (bottomTwoRightItems) {
			//looping through the bottom 2 simple right aligned items
			for (const key of Object.keys(bottomTwoRightItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomTwoLevelRightItem order={enabledColumns[key]} key={index}>
							<span>{bottomTwoRightItems[key]}</span>
						</BottomTwoLevelRightItem>
					);
					index++;
				}
			}
		}

		if (bottomTwoDetailItems) {
			//looping through the bottom 2 flex 1 items
			for (const key of Object.keys(bottomTwoDetailItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomTwoLevelDetailItem order={enabledColumns[key]} key={index}>
							<span>{bottomTwoDetailItems[key]}</span>
						</BottomTwoLevelDetailItem>
					);
					index++;
				}
			}
		}

		if (bottomTwoGreyItems) {
			//looping through the bottom 2 simple grey items
			for (const key of Object.keys(bottomTwoGreyItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomTwoLevelGreyItem order={enabledColumns[key]} key={index}>
							<span>{bottomTwoGreyItems[key]}</span>
						</BottomTwoLevelGreyItem>
					);
					index++;
				}
			}
		}
	}
	return (
		<>
			<BottomTwoLevelTableRow
				isFirstRow={isFirstRow}
				isExpanded={isExpanded}
				numberOfParents={numberOfParents}
				numberOfLevels={numberOfLevels}
				onClick={isExpanded !== undefined ? show : () => {}}
				isLastRow={isLastRow}
				stickyTopPosition={stickyTopPosition}
			>
				{list}
			</BottomTwoLevelTableRow>
		</>
	);
};

BottomTwoLevelRow.propTypes = {
	isVisible: PropTypes.bool,
	numberOfLevels: PropTypes.bool,
	isLastRow: PropTypes.bool,
	isFirstRow: PropTypes.bool,
	isExpanded: PropTypes.bool,
	mainItem: PropTypes.object,
	reportedTime: PropTypes.string,
	assigneesElement: PropTypes.object,
	projectName: PropTypes.string,
	roleName: PropTypes.string,
	price: PropTypes.string,
	cost: PropTypes.string,
	notes: PropTypes.string,
	taskName: PropTypes.string,
	personIcon: PropTypes.object,
	timeRegType: PropTypes.string,
	showBottom: PropTypes.func,
	stickyTopPosition: PropTypes.number,
	projectIcon: PropTypes.object,
	timeRegDetail: PropTypes.string,
	date: PropTypes.string,
	departmentName: PropTypes.string,
	clientName: PropTypes.string,
	billable: PropTypes.string,
	bottomTwoItems: PropTypes.object,
	bottomTwoDetailItems: PropTypes.object,
	bottomTwoGreyItems: PropTypes.object,
	bottomTwoRightItems: PropTypes.object,
	numberOfParents: PropTypes.number,

	enabledColumns: PropTypes.shape({
		needingSpace: PropTypes.bool,
		projectIcon: PropTypes.bool,
		mainItem: PropTypes.bool,
		caretIcon: PropTypes.bool,
		personIcon: PropTypes.bool,
		personName: PropTypes.bool,
		reportedTime: PropTypes.bool,
		timeRegType: PropTypes.bool,
		timeRegDetail: PropTypes.bool,
		projectName: PropTypes.bool,
		roleName: PropTypes.bool,
		price: PropTypes.bool,
		cost: PropTypes.bool,
		date: PropTypes.bool,
		notes: PropTypes.bool,
		taskName: PropTypes.bool,
		showBottom: PropTypes.bool,
		departmentName: PropTypes.bool,
		clientName: PropTypes.bool,
		billable: PropTypes.bool,
	}).isRequired,
};
